export const UPDATE_USER_WORKSPACE_OPTIN_STATE = "UPDATE_USER_WORKSPACE_OPTIN_STATE";
export const WORKSPACE_OPTIN_DISMISS_DOT_SHOW = "WORKSPACE_OPTIN_DISMISS_DOT_SHOW";
